export default __webpack_public_path__ + "alberta-team.8f206e397681c6fe3c83.svg";